export default [
  'http://172.20.21.185:7879/bigdata/business/dataCollect',
  'https://bigdate-analysis.zczy56.com/bigdata/business/dataCollect',
  '/oms-consignor-pc/hugeOrder/consignor/queryHugeWeightInfo',
  '/oms-consignor-pc/consignor/receiptConfirm/queryBatchReceiptSubmitProcess',
  '/whale-aio-sso-server/app/sys/loginWeb',
  '/whale-pc/role/querySystemRolePermission'
];
